<div class="subBlockContainer" id="portalBranding">
  <div class="subBlockContent">
    <div class="inner-subBlock-wrapper">
      <div class="page-title-wrapper">
        <div class="page-title-position">
          {{title}}
        </div>
        <i class="material-icons pullfloat-right" (click)="close()">close</i>
      </div>
      <!-- Input to upload logo -->
      <div class="shared-outer-wrapper">
        <img id="uploadedImg" [src]="imageSrc || '../images/new_ui/RenderCompanyLogo.png'" />
        <label for="upload">
          <input type="file" name="image" accept="image/*" id="upload" style="display:none"  (change)="readURL($event)" (change)="onSelectFile($event)">
          <div class="upload-wrapper">Select file</div>
        </label>
      </div>
      <!-- URL -->
      <section>
        <label for="domain">URL</label>
        <span>https://</span>
        <input id="domain" [(ngModel)]="defaultUrl" [value]="defaultUrl"> 
        <span>.cloudportal.net</span>
        <img src="../images/new_ui/url-check.png" alt="">
      </section>
      <!-- Color Picker -->
      <section>
        <label>Accent Colour</label>
        <input [value]="color"
        [cpCancelButton]="true"
        [(ngModel)]="color"
        [cpCancelButtonClass]= "'btn btn-primary btn-xs'"
        [(colorPicker)]="color" id="color-picker" [cpAlphaChannel]="'disabled'" [cpOutputFormat]="'hex'"/>
        <div class="color-displayer" [style.background]="color"></div>
      </section>
      <!-- Preview Mood -->
      <section>
        <div class="shared-outer-wrapper">
          <img id="previouImg" [src]="imageSrc || '../images/new_ui/RenderCompanyLogo.png'" />
        </div>
      </section>
      <!-- Save Button -->
      <section>
        <button id="saveBtn" class="button button-red button-large" (click)="saveBrandingConfig()">Save</button>
      </section>
    </div>
    <loading-screen *ngIf="!loadContent" backDropWidth='350' [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)"></loading-screen>
  </div>
</div>